import styled from 'styled-components';

import { COLORS } from '@theme/colors';

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CountDownContainer = styled.div`
  position: relative;
  display: flex;
  gap: 10px;
  font-size: 10px;
  color: ${COLORS.SILVER_CHALICE};
`;

export const Segment = styled.div`
  max-width: 45px;
  line-height: 1.2;
`;

export const Label = styled.div`
  font-size: 10px;
`;
